import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.companyDetailPage || initialState;

export const selectCompanyDetailPage = createSelector(
  [selectSlice],
  state => state,
);
